import {appFirestore, appAuth} from "../../../index";
import {store} from "../../store";
import {createTransportClientWriter, TransportClientMutation} from "./transportClientMutations";

// Client-only release: keep existing Firestore access and business roles.
// No callable, resource-lock collection or server authorization is introduced.
let writer: ReturnType<typeof createTransportClientWriter> | undefined;
export function saveTransportMutation(mutation: TransportClientMutation): Promise<string> {
    // index.tsx imports the screens before initializing Firebase: defer access until a UI action.
    writer = writer || createTransportClientWriter(appFirestore, () => {
        const employee = store.getState().app.currentEmployee;
        return {id: employee?.id ?? null, name: employee?.name ?? "Неизвестен потребител"};
    }, () => appAuth.currentUser?.uid ?? "");
    return writer(mutation);
}

export function transportMutationError(error: unknown): string {
    const message = (error as {message?: unknown})?.message;
    return typeof message === "string" && message.trim() ? message :
        "Неуспешно записване. Презаредете приложението и опитайте отново.";
}
